import type { ProductSamplingItemProps } from './ProductSamplingsList/ProductSamplingItem/ProductSamplingItem';
import ProductSamplingList from './ProductSamplingsList/ProductSamplingList';
import type { ProductServiceItemProps } from './ProductServiceList/ProductServiceItem/ProductsServiceItem';
import { ProductServiceList } from './ProductServiceList';

interface ProductExtraListProps {
  services?: ProductServiceItemProps[];
  samples?: ProductSamplingItemProps[];
}

const ProductExtraList: React.FC<ProductExtraListProps> = ({
  services,
  samples
}) => {
  return (
    <div className="co-flex co-flex-col co-gap-3  ">
      {samples && <ProductSamplingList samples={samples} />}
      {services && <ProductServiceList services={services} />}
    </div>
  );
};

export default ProductExtraList;
